import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=0c674c54&scoped=true&"
import script from "./ImportFile.vue?vue&type=script&lang=js&"
export * from "./ImportFile.vue?vue&type=script&lang=js&"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=0c674c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c674c54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c674c54')) {
      api.createRecord('0c674c54', component.options)
    } else {
      api.reload('0c674c54', component.options)
    }
    module.hot.accept("./ImportFile.vue?vue&type=template&id=0c674c54&scoped=true&", function () {
      api.rerender('0c674c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/upload/ImportFile.vue"
export default component.exports